import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react';
import * as RC from '@radix-ui/react-checkbox';
import { Check, Minus } from 'lucide-react';
import { cn } from '../../lib/cn';

/**
 * Checkbox primitive (wrapper over Radix Checkbox).
 *
 * Renders an `<Indicator>` with `<Check>` for the checked state and `<Minus>`
 * for the indeterminate state. Visual focus ring goes around the box.
 */
export const Checkbox = forwardRef<
  ElementRef<typeof RC.Root>,
  ComponentPropsWithoutRef<typeof RC.Root>
>(function Checkbox({ className, ...props }, ref) {
  return (
    <RC.Root
      ref={ref}
      className={cn(
        'peer h-4 w-4 shrink-0 rounded border border-border bg-bg-input transition-colors ' +
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary ' +
          'focus-visible:ring-offset-2 focus-visible:ring-offset-bg ' +
          'data-[state=checked]:border-primary data-[state=checked]:bg-primary ' +
          'data-[state=indeterminate]:border-primary data-[state=indeterminate]:bg-primary ' +
          'data-[state=checked]:text-white disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <RC.Indicator className="flex items-center justify-center text-white">
        {props.checked === 'indeterminate' ? <Minus size={12} aria-hidden /> : <Check size={12} aria-hidden />}
      </RC.Indicator>
    </RC.Root>
  );
});
